/*
Author : Arman Ali
Module: Department
github: https://github.com/Arman-Arzoo
*/
import { createSlice } from '@reduxjs/toolkit';
import { ResponseApi } from '../BaseApi';

const ApprovalSlice = createSlice({
    name: 'approvalSection',
    initialState: {
        getAllApproval: [],
        createApproval: {},
        updateApproval: {},
        deleteApproval: {},
        getApprovalById: null,
        getListApprovalModules:[]
    },
    reducers: {},
    extraReducers: {
        'approvalSection/getAllApproval/fulfilled': (state, action) => {
            state.getAllApproval = ResponseApi(action.payload);
        },
        'approvalSection/createApproval/fulfilled': (state, action) => {
            state.createApproval = ResponseApi(action.payload);
        },
        'approvalSection/updateApproval/fulfilled': (state, action) => {
            state.updateApproval = ResponseApi(action.payload);
        },
        'approvalSection/deleteApproval/fulfilled': (state, action) => {
            state.deleteApproval = ResponseApi(action.payload);
        },
        'approvalSection/getListApprovalModules/fulfilled': (state, action) => {
            state.getListApprovalModules = ResponseApi(action.payload);
        },
        'approvalSection/getApprovalById/fulfilled': (state, action) => {
            state.getApprovalById = ResponseApi(action.payload);
        },
    },
});

export const {} = ApprovalSlice.actions;

export default ApprovalSlice.reducer;
